// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleBase from "#/common/ModuleBase";

// Components
import { GalleryItem } from "./item/GalleryItem";
import { Headline } from "#/components/headline/Headline";
import { WeightedRowThree } from "./weighted_row_three/WeightedRowThree";
import { WeightedRowFour } from "./weighted_row_four/WeightedRowFour";
import { WeightedRowSix } from "./weighted_row_six/WeightedRowSix";
import { getTranslatedImage as getTranslatedImageHelper } from "#/common/ModuleHelpers";

interface GalleryImage {
  image?: object;
  enlarge?: boolean;
  video?: object;
  text?: string;
}

@Component({
  mixins: [template],
  components: {
    GalleryItem,
    Headline,
    WeightedRowThree,
    WeightedRowFour,
    WeightedRowSix,
  },
})
export class Gallery extends Vue {
  private isMobile: boolean = false;

  @Prop({ default: "weighted" })
  public type!: "slider" | "storyslider" | "weighted" | "unweighted";

  @Prop({ default: "en" })
  public lang!: string;

  @Prop({ default: "black" })
  public backgroundColor!: "black" | "white";

  @Prop()
  public images!: GalleryImage[];

  public created() {
    window.addEventListener("resize", this.handleResize);
  }

  public mounted() {
    this.handleResize(undefined);
  }

  public destoyed() {
    window.removeEventListener("resize", this.handleResize);
  }

  private handleResize(e?: Event) {
    const windowWidth =
      document.documentElement!.clientWidth || document.body.clientWidth;

    this.isMobile = windowWidth < 768;
  }

  public isVideo(item) {
    return (
      item["video"] &&
      item["video"] != "" &&
      (item["video"]["embedUrl"] || item["video"]["uploadUrl"])
    );
  }

  public getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }
}
